import { message, Spin } from "antd";
import { isAxiosError } from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useChangePassword } from "@hooks/useChangePassword";
import { LoginResetPassword } from "@components/molecules";
import { ArrowLeft } from "@phosphor-icons/react";

export const ChangePassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const { changePassword, isLoading } = useChangePassword();

  const handleChangePassword = (data: { password: string }) => {
    if (!token) {
      message.error("Reset token not found. Please request a new password reset link.");
      return;
    }

    changePassword.mutate(
      { token, newPassword: data.password },
      {
        onSuccess: () => {
          message.success("Password changed successfully! You can now log in.");
          navigate("/login");
        },
        onError: (error) => {
          if (isAxiosError(error)) {
            message.error(error.response?.data.message || 'Error changing password');
          }
        },
      }
    );
  };

  return (
    <Spin spinning={isLoading}>
      <div className="flex min-h-screen bg-[url(/background-login.jpg)] bg-cover bg-center">
        {/* Left Panel */}
        <div className="hidden flex-1 flex-col justify-center p-10 relative md:flex bg-black bg-opacity-50">
          <div className="absolute top-5 left-5">
            <a href="https://www.estabrookinc.com/" className="text-secondary hover:text-white flex items-center gap-2 text-xs font-light">
              <ArrowLeft />
              Back to website
            </a>
          </div>
          <div className="absolute top-20 left-10 w-20">
            <img src="/assets/logos/ruppert-logo.svg" alt="Estabrook" />
          </div>
          <h1 className="text-primary text-6xl font-extralight font-azonix">
            Empowering your legacy with AI
          </h1>
        </div>

        {/* Right Panel - Form */}
        <div className="flex flex-col justify-center p-8 bg-white shadow w-full md:max-w-md md:p-10">
          <div className="mb-10 flex justify-center">
            <img src="/assets/logos/estabrook-logo-dark.svg" alt="Estabrook" className="w-40" />
          </div>
          {/* Note: The LoginChangePassword component should also be updated internally to use the global Ant Design styles */}
          <LoginResetPassword onFinish={handleChangePassword} />
        </div>
      </div>
    </Spin>
  );
};